import React from 'react';
import Card from '../../components/ui/Card.jsx';

export default function StudentContact() {
  return (
    <div className="page contact-page">
      <section className="card contact-hero">
        <div className="contact-hero-content">
          <h1>ECE Department Contact</h1>
          <p className="subtle">
            Reach the Electrical and Computer Engineering department for student support, office inquiries, and
            advising resources.
          </p>
          <div className="contact-hero-actions">
            <a className="btn btn-primary" href="tel:+13233434470">Call Department</a>
            <a className="btn btn-secondary" href="mailto:ee.ecst@calstatela.edu">Send Email</a>
            <a className="btn btn-ghost" href="https://www.calstatela.edu/ecst/ece" target="_blank" rel="noreferrer">
              Visit ECE Website
            </a>
          </div>
        </div>
      </section>

      <div className="grid two contact-layout">
        <Card title="ECE Department Contact Info">
          <dl className="contact-list" aria-label="ECE department contact information">
            <div className="contact-item">
              <dt>Room</dt>
              <dd>ET A342</dd>
            </div>
            <div className="contact-item">
              <dt>Phone</dt>
              <dd>
                <a href="tel:+13233434470">(323) 343-4470</a>
              </dd>
            </div>
            <div className="contact-item">
              <dt>Email</dt>
              <dd>
                <a href="mailto:ee.ecst@calstatela.edu">ee.ecst@calstatela.edu</a>
              </dd>
            </div>
            <div className="contact-item">
              <dt>Address</dt>
              <dd>
                <a
                  href="https://maps.google.com/?q=5151+State+University+Drive,+Los+Angeles,+CA+90032"
                  target="_blank"
                  rel="noreferrer"
                >
                  5151 State University Drive, Los Angeles, CA 90032
                </a>
              </dd>
            </div>
            <div className="contact-item">
              <dt>Website</dt>
              <dd>
                <a href="https://www.calstatela.edu/ecst/ece" target="_blank" rel="noreferrer">
                  https://www.calstatela.edu/ecst/ece
                </a>
              </dd>
            </div>
          </dl>
        </Card>

        <Card title="Advisement Resources">
          <div className="contact-advising">
            <p className="subtle">
              For advising, use the official ECE advisement page for appointment steps, forms, and current student
              guidance.
            </p>
            <a
              className="btn btn-primary"
              href="https://www.calstatela.edu/ecst/ece/advisement-resources"
              target="_blank"
              rel="noreferrer"
            >
              Open Advisement Resources
            </a>
          </div>
        </Card>
      </div>
    </div>
  );
}
